import React from "react";
import Input from "../../common/input";

const MobileRecordingHeader = props => {
  return (
    <div>
      {props.title ? <h3>{props.title}</h3> : null}
      {props.subTitle ? <h4>{props.subTitle}</h4> : null}
      {props.searchable ? (
        <Input
          name="searchText"
          onChange={props.searchHandler}
          value={props.value}
          autoFocus={props.value && props.value.length > 0 ? true : null}
          placeholder={"search"}
        ></Input>
      ) : null}
    </div>
  );
};

export default MobileRecordingHeader;
